import script from "./TabPotentialUnits.vue?vue&type=script&setup=true&lang=js"
export * from "./TabPotentialUnits.vue?vue&type=script&setup=true&lang=js"

import "./TabPotentialUnits.vue?vue&type=style&index=0&id=51ccdcbe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51ccdcbe"]])

export default __exports__